/*
 * Theme alias for customize step content (CustomizeStepsContent).
 * Reuses ConfigurationSelector multi-style parts so styles stay in one place (P1-2).
 */
import ConfigurationSelector from '@amblique/king-living/app/theme/components/project/configuration-selector';

const CustomizeSteps = {
  parts: ConfigurationSelector.parts,
  baseStyle: ConfigurationSelector.baseStyle,
};

export default CustomizeSteps;
